//  @flow

import React from 'react';

import Meta from '../../Components/Meta';

import LazyComponent from '../../Components/LazyComponent';

import './style.css';
import Topics from './Topics';
import Banner from './Banner';
import Content from './Content';
import Giveaways from './Giveaways';
import ContactForm from './ContactForm';
import Roadmap from './Roadmap/index';

const Workshop = () => (
  <main>
    <Meta
      title="Workshop | Alien Brains Educations"
      description="Alien Brains Educations is one of the premier institutes having classroom like mentorship program for summer and winter online training programs under industry professionals."
    />
    <LazyComponent>
      <Banner />
    </LazyComponent>
    <LazyComponent>
      <Topics />
    </LazyComponent>
    <LazyComponent>
      <Giveaways />
    </LazyComponent>
    {/* <LazyComponent>
      <Roadmap />
    </LazyComponent> */}
    <LazyComponent>
      <ContactForm />
    </LazyComponent>
  </main>
);

export default Workshop;



// WEBPACK FOOTER //
// ./src/Pages/Workshop/index.js